import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SOURCE_CHAT } from "../../../constants.js";
import {
    setExpiredScheduler,
    setLoadingReply,
} from "../../features/messagesSlice.js";
import useSendData from "../../hooks/useSendData.js";
import useRefreshData from "../../hooks/useRefreshData.js";
import SendMessageButton from "../atoms/buttons/SendMessageButton.jsx";
import TextInput from "../atoms/texts/TextInput.jsx";
import MessageLimit from "../atoms/texts/MessageLimit.jsx";

export default function SendMessage() {
    const dispatch = useDispatch();
    const textBoxContainer = useRef(null);
    const expiredAt = useSelector(state => state.messages.expiredAt);
    const connectedLiveAgent = useSelector(state => state.liveAgent.connectedLiveAgent);
    const retryLiveAgent = useSelector(state => state.liveAgent.retryLiveAgent);
    const liveAgentUnavailable = useSelector(state => state.liveAgent.liveAgentUnavailable);
    const loadingReply = useSelector(state => state.messages.loadingReply);
    const expiredScheduler = useSelector(state => state.messages.expiredScheduler);
    const isEnd = useSelector(state => state.messages.isEnd);
    const messages = useSelector(state => state.messages.messages);
    const messageLimit = useSelector(state => state.messages.messageLimit);
    const { sendMessage } = useSendData();
    const { handleExpirySchedule, refreshChat } = useRefreshData();

    useEffect(() => {
        if (expiredScheduler) clearInterval(expiredScheduler);
        if (expiredAt && !isEnd) {
            const scheduler = setInterval(() => {
                handleExpirySchedule();
            }, 30000);
            dispatch(setExpiredScheduler(scheduler));
        } else if (isEnd) {
            clearInterval(expiredScheduler);
        }
    }, [expiredAt, isEnd, messages]);

    useEffect(() => {
        if (retryLiveAgent) {
            sendNewMessage(textBoxContainer);
        }
    }, [retryLiveAgent]);

    // Genesys Refresh Chat
    useEffect(() => {
        refreshChat();
    }, [connectedLiveAgent]);

    const sendNewMessage = async (textBoxContainer) => {
        if (SOURCE_CHAT === "RIB") {
            // Note: Method is declared in parent HTML block
            // eslint-disable-next-line no-undef
            closeTimerDialog();

            // Note: Method is declared in parent HTML block
            // eslint-disable-next-line no-undef
            startSessionTimer();

            // Note: Method is declared in parent HTML block
            // eslint-disable-next-line no-undef
            keepSessionAlive();
        }

        if (!loadingReply || retryLiveAgent) {
            if (!connectedLiveAgent) dispatch(setLoadingReply(true));

            const containerElement = textBoxContainer.current;
            let userInput = containerElement.innerHTML
                .replace(/<div>|<br.*?>/gi, "\n")
                .replace(/<\/div>/g, "")
                .replace(/&nbsp;/g, " ")
                .replace(/&amp;/g, "&")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, "\"")
                .replace(/&apos;/g, "'")
                .replace(/\n/g, "<br>")
                .trim();

            if (retryLiveAgent) userInput = "Retry Live Agent";
            // Mask user input
            userInput = userInput.replace(/(\d[\s|\-|\\|/|_|,]?){10,}/g, match => match.replace(/\d/g, "*"));

            containerElement.textContent = "";
            containerElement.focus();

            await sendMessage(userInput);

        }
    };

    return (
        <div className="send-message">
            { (!isEnd && !liveAgentUnavailable) && (
                <div className="text-input">
                    <TextInput sendNewMessage={ sendNewMessage } textBoxContainer={ textBoxContainer }/>
                    <SendMessageButton sendNewMessage={ () => sendNewMessage(textBoxContainer) }/>
                </div>
            ) }
            { messageLimit && (
                <MessageLimit/>
            ) }
        </div>
    );
};
